import Navbar from '../components/Navbar';
import Registration from '../components/Registration';
import Footer from '../components/Footer';

const PageRegistration = () => {
  return (
    <div>
      <Navbar />
      <Registration />
      <Footer />
    </div>
  );
};

export default PageRegistration;
